<template>
  <!--<div class="triplet__left">-->
  <div
    :class="[
      'maps__col',
      'maps__col--layers',
      { overflowHidden: (!general.isMobile && innerContainerSize) > 600 }
    ]"
  >
    <!--<div class="switch-pill">
      <div class="switch-pill__wrap">
        <button
          title="Přepnout na piny"
          class="switch-pill__single"
          v-bind:class="{
            'switch-pill__single--active': general.controlsLeft === 'pins'
          }"
          @click="setControlsLeft('pins')"
        >
          Přílohy k vrstvám
        </button>
        <button
          title="Přepnout na legendu"
          href="#"
          class="switch-pill__single"
          v-bind:class="{
            'switch-pill__single--active': general.controlsLeft === 'caption'
          }"
          @click="setControlsLeft('caption')"
        >
          Legenda
        </button>
      </div>
    </div>-->
    <!--<div
      class="switchable"
      v-bind:class="{
        'switchable--active': general.controlsLeft == 'caption'
      }"
    >
      <strong>Legenda</strong>
      <LayerSettings
        v-for="sl in orderedLayers"
        :key="sl.id"
        :layer="sl"
      ></LayerSettings>
    </div>
    <div
      class="switchable"
      v-bind:class="{
        'switchable--active': general.controlsLeft == 'pins'
      }"
    >
      <strong>Piny</strong>
      <LayerPins
        v-for="sl in orderedLayers"
        :key="sl.id"
        :layer="sl"
      ></LayerPins>
    </div>
    </div>-->
    <div class="switchers-bottom-fixed__container">
      <div
        v-resize="flex"
        :class="[
          'switchers-inner__container',
          { 'inner-flex': (!general.isMobile && innerContainerSize) > 600 }
        ]"
        ref="container--captions"
      >
        <div
          :class="[
            'captions',
            {
              'no-stretch': innerContainerSize > 600
            }
          ]"
          ref="captions"
        >
          <strong>Legenda</strong>
          <div v-if="buttons.length !== 0">
            <br />
            <strong v-if="currentArea">{{ currentArea.name }}</strong>
            <WizardEventDispatcher
              :event="'click'"
              :target="{ type: 'custom-button', id: button.id }"
              v-for="button in buttons"
              :key="button.id"
            >
              <CustomButton
                :areaId="button.areaId"
                :title="button.title"
                :fontSize="button.style_fontSize"
                :textColor="button.style_textColor"
                :fontWeight="button.style_fontWeight"
                :backgroundColor="button.style_bgColor"
                :destination="button.destination"
              ></CustomButton>
            </WizardEventDispatcher>
          </div>
          <LayerSettings
            v-for="sl in orderedLayers"
            :key="sl.id"
            :layer="sl"
            :subLayers="layers.subLayers[sl.id]"
            :openedLayers="openLayersParsed"
            :buttons="
              buttonsLayer
                ? buttonsLayer.hasOwnProperty(sl.id)
                  ? buttonsLayer[sl.id]
                  : null
                : null
            "
          ></LayerSettings>
        </div>
        <div class="pins" ref="pins">
          <strong>Piny</strong>
          <div
            v-for="pt in threads.fetchedPinTypes"
            :key="'pt-' + pt"
            class="pin-type"
          >
            <img
              :src="threads.pinTypes[pt].pin_url"
              :alt="'Pin ' + threads.pinTypes[pt].name"
            />
            {{ threads.pinTypes[pt].name }}
          </div>
          <div class="pin-type">
            <img :src="threadPinUrl" alt="Pin - Přípomínky občanů" />
            Připomínky občanů
          </div>
          <LayerPins
            v-for="sl in orderedLayers"
            :key="'pin-' + sl.id"
            :layer="sl"
            :subLayers="layers.subLayers[sl.id]"
            :openedPinLayers="openPinLayersParsed"
            :openedPins="openPinsParsed"
          ></LayerPins>
        </div>
      </div>
      <div class="switchers-bottom-fixed" v-show="!general.layout.sidebarRight">
        <ToggleSwitch layout-part="phasesTimeline"
          >Fáze &amp; Další vrstvy</ToggleSwitch
        >
        <!--<ToggleSwitch layout-part="layers">Další vrstvy</ToggleSwitch>-->
      </div>
    </div>
  </div>
</template>

<script>
import LayerSettings from '@/components/LayerSettings.vue';
import ToggleSwitch from '@/components/ToggleSwitch.vue';
import LayerPins from '@/components/LayerPins.vue';
import CustomButton from '@/components/CustomButton.vue';
import resize from 'vue-resize-directive';
import WizardEventDispatcher from '@/components/wizard/WizardEventDispatcher.vue';
import { MARKER_ICONS } from '@/constants/gmaps.js';

import { mapState, mapActions, mapGetters } from 'vuex';

export default {
  directives: {
    resize
  },
  props: {
    orderedLayers: {
      type: Array,
      required: true
    }
  },
  components: {
    LayerSettings,
    ToggleSwitch,
    LayerPins,
    CustomButton,
    WizardEventDispatcher
  },
  data() {
    return {
      innerContainerSize: 0
    };
  },
  computed: {
    ...mapState(['general', 'layers', 'threads']),
    ...mapActions(['general/setControlsLeft']),
    ...mapGetters({
      buttonsLayer: ['general/buttonsLayer'],
      buttons: ['general/buttonsAboveCaption'],
      currentArea: ['general/currentArea']
    }),
    openLayersParsed: function () {
      return JSON.parse(this.$route.params.openSettings);
    },
    openPinLayersParsed: function () {
      return JSON.parse(this.$route.params.openPinLayers);
    },
    openPinsParsed: function () {
      return JSON.parse(this.$route.params.openPins);
    },
    threadPinUrl: function () {
      return MARKER_ICONS['Zpracovatel'];
    }
  },
  methods: {
    setControlsLeft(controls) {
      this.$store.dispatch('general/setControlsLeft', controls);
    },
    flex() {
      const width = this.$refs['container--captions'].offsetWidth;
      this.innerContainerSize = width;
    }
  },
  watch: {
    'general.layout.sidebarRight'(newValue) {
      if (!newValue) {
        this.$refs.captions.scrollIntoView();
      }
    }
  }
};
</script>

<style scoped>
.maps__col--layers,
.maps__col--comments {
  position: relative;
  min-height: 100%;
}
.switchers-bottom-fixed__container {
  position: relative;
  /* padding-bottom: 3.5rem; */
  min-height: 100%;
  height: 100%;
}
.switchers-bottom-fixed {
  /* position: absolute; */
  bottom: 0.5rem;
  padding-top: 2rem;
}
.pins {
  flex: 1;
}
.captions.no-stretch {
  max-width: 300px;
}
.inner-flex .pins {
  overflow: auto;
}
.inner-flex .captions {
  overflow: auto;
}
.pin-type {
  display: flex;
  align-items: center;
  padding: 0.3rem;
}
.pin-type img {
  display: inline-block;
  max-width: 20px;
  margin-right: 0.4rem;
}
.switchers-inner__container {
  display: flex;
  flex-direction: column;
}

.switchers-inner__container.inner-flex {
  display: flex;
  flex-direction: row;
  overflow: hidden;
  height: 100%;
  min-height: 100%;
}
.overflowHidden {
  overflow: hidden;
}
</style>
